import React,{memo, useContext,useEffect,useState,useRef,useMemo} from 'react'
import { UserSettingsContext } from '../../../setup/routes-manager/RequireAuth'
import { captureChartInteraction } from '../../../analytics/chartsTool';
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../../common/api/urls';
import { useNavigate, useLocation } from 'react-router-dom';
import { TEXT_MSGS,TABLE_TYPES,OF_ZOOM_TYPE, USER_ROLE_FIELDS } from '../../../common/utility/constant';
// ============================================================
// NEW - Centralized Permission System
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from '../../../common/hooks/usePermissions';
import { CircularProgress,InputLabel,Switch,Radio,RadioGroup,FormControlLabel,FormLabel, Link ,Checkbox,useTheme} from '@mui/material';
import {Grid, Box,Typography,Select,ListSubheader,TextField,InputAdornment,FormControl,MenuItem} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsFooter from './settings_footer';
import { findIndex } from '@amcharts/amcharts5/.internal/core/util/Array';
import { VP_TYPE,VA_TYPE, MAIN_PANEL_ON_BOTTOM_PANEL, BOTTOM_PANEL_HEIGHT_VAL, BOTTOM_PANEL_VIEWS, INFO_PANEL_VIEWS } from '../../../common/utility/mp_chart_constants';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { createDictList, getBottomPanelDefaultHeight, getBottomPanelHeightName, getBottomPanelViewName, getGammaSettingsName, getInfoPanelViewName, getIvRangeBottomPanelHeightName, getIvRangeBottomPanelVisibleName, getLVOSettingsName, getLineChartSettingsName, getMvizSettingsName, isD3BasedLineChart,isGammaAndMvizSettingsAvailable, isLvoSettingsAvailable, transformAndReverseMap } from '../../../common/utility/helperFunc';
import Modal from '@mui/material/Modal';
import AppErrorPopup from '../../../components/AppErrorPopup';

import { List } from 'react-virtualized';
import 'react-virtualized/styles.css'; // Import the styles for the List component
import useMediaQuery from '@mui/material/useMediaQuery';
import SettingsFooterPopup from './settings_footer_popup';
import SettingsModalCloseButton from './settings_modal_close_button';
import { setIn } from 'formik';
import useAuth from '../../../common/hooks/useAuth';
import { deregisterFCMToken, requestNotificationPermission } from '../../../firebase';


const style = {
    position: 'absolute',
    top: '5%',
    left: '10%',
    height: "90%",
    //   transform: 'translate(-50%, -50%)',
    width: "80%",
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 0,
    overflow: 'scroll',
  };

const containsText = (text, searchText) =>{
  return text.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
}


 const ITEM_HEIGHT = 26;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
   PaperProps: {
     style: {
       maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
       width: 80,
       autoFocus: false
     },
   },
 };

 const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));
const LineChartSettingsNew= (props) => {
  const from = "/login";
  const theme=useTheme();
  const { auth } = useAuth();
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  
  // ============================================================
  // OLD - Hardcoded Admin and PRO2 user checks (DEPRECATED)
  // Replaced by: permissions.isAdmin(), permissions.isEliteUser()
  // See: src/common/utility/permissionService.js
  // ============================================================
  // const isAdmin=(auth.role.find(el=>el==USER_ROLE_FIELDS.ADMIN))?true:false;
  // const [isPro2User,setIsPro2User]=useState((auth.role.find(el=>el==USER_ROLE_FIELDS.PRO2))?true:false)
  
  // NEW - Use centralized permission service
  const isAdmin = permissions.isAdmin();
  // PRO2-only feature 
  const [isPro2User,setIsPro2User]=useState(permissions.isPro2User())
  const [hasNotifAccess,setHasNotifAccess]=useState(permissions.hasPushNotificationAccess());
  const [modalOpen, setModalOpen] = React.useState(props.open);
  const navigate = useNavigate(); 
  const [searchText, setSearchText] = React.useState("");
  const inputRef = React.useRef();
  const [options,setOptions]=useState();
  const { userSettings, setUserSettings } = useContext(UserSettingsContext);
  const [selectedInstrument, setSelectedInstrument] = React.useState(userSettings.data.default_instrument);
  const [showGlobalVolumeProfile,setShowGlobalVolumeProfile ] =useState(userSettings.data.show_global_vp);
  const [showAllVolumeProfile,setShowAllVolumeProfile ] =useState(userSettings.data.show_all_vp);
  const [showGlobalVolumeNumberProfile,setShowGlobalVolumeNumberProfile ] =useState(userSettings.data.show_global_vp_numbers);
  const [showAllVolumeNumber,setShowAllVolumeNumber ] =useState(userSettings.data.show_profile_vp_numbers);
  const [showUiNpocKrl,setShowUiNpocKrl ] =useState(userSettings.data.show_ui_npoc_krl!=undefined?userSettings.data.show_ui_npoc_krl:true);
  const [showKrl,setShowKrl ] =useState(userSettings.data.show_krl!=undefined?userSettings.data.show_krl:false);
  const [showCustomKrl,setShowCustomKrl ] =useState(userSettings.data.custom_krl_display!=undefined?userSettings.data.custom_krl_display:false);
  const [customKrlMultipleAnchor,setCustomKrlMultipleAnchor ] =useState(userSettings.data.custom_krl_overlapping_anchoring!=undefined?userSettings.data.custom_krl_overlapping_anchoring:false);
  const [anchorVwap2sdDisplay,setAnchorVwap2sdDisplay ] =useState(userSettings.data.show_2sd_band_custom_anchored_krl!=undefined?userSettings.data.show_2sd_band_custom_anchored_krl:false);
  const [showOFNPOC,setShowOFNPOC ] =useState(userSettings.data.show_ui_npoc_krl_of!=undefined?userSettings.data.show_ui_npoc_krl_of:true);
  const [showOFMetadata,setShowOFMetadata ] =useState(userSettings.data.show_metadata_marker_of!=undefined?userSettings.data.show_metadata_marker_of:true);
  const [vpType,setVPType]=useState(userSettings.data.vp_type)
  const [vaType,setVAType]=useState(userSettings.data.va_type)
  const [maxCompositeDays,setMaxCompositeDays]=useState(userSettings.data.max_ndays_for_composite)
  const [defaultLineChartNDays,setDefaultLineChartNDays]=useState(userSettings.data.default_lc_ndays)
  const [autosaveInterval,setAutosaveInterval]=useState(userSettings.data.autosave_interval)
  const [numberFormatLocale,setNumberFormatLocale]=useState(userSettings.data.number_format_locale)
  const [dataTypeContracts,setDataTypeContracts]=useState(userSettings.data.data_in_contracts);
  const [ordeflowZoomType,setOrdeflowZoomType]=useState(userSettings.data.of_zoom_type?userSettings.data.of_zoom_type:OF_ZOOM_TYPE.ASYMMETRIC)
  // const [lcMainPanelView,setLCMainPanelView]=useState(userSettings.data.lc_main_panel_view?userSettings.data.lc_main_panel_view:MAIN_PANEL_ON_BOTTOM_PANEL.HIDE);
  const [lcBottomPanelView,setLCBottomPanelView]=useState(userSettings.data[getBottomPanelViewName(props.plot)]?userSettings.data[getBottomPanelViewName(props.plot)]:BOTTOM_PANEL_VIEWS.TOP_LAYER);
  const [value, setValue] = useState(userSettings.data[getBottomPanelHeightName(props.plot)]?userSettings.data[getBottomPanelHeightName(props.plot)]:getBottomPanelDefaultHeight(props.plot));
  const [infoPanelView,setInfoPanelView]=useState(userSettings.data[getInfoPanelViewName(props.plot)]?userSettings.data[getInfoPanelViewName(props.plot)]:INFO_PANEL_VIEWS.EXPANDED);
  const [showGammaLines,setShowGammaLines]=useState(userSettings.data[getGammaSettingsName(props.plot)]!=undefined?userSettings.data[getGammaSettingsName(props.plot)]:true);
  const [showMvizLines,setShowMvizLines]=useState(userSettings.data[getMvizSettingsName(props.plot)]!=undefined?userSettings.data[getMvizSettingsName(props.plot)]:true);
  const [browserPushNotification, setBrowserPushNotification]=useState(userSettings.data.browser_push_notifications!=undefined?userSettings.data.browser_push_notifications:false);
  const [isNotificationChanged,setNotificationChanged]=useState(false);
  const [showLvo,setShowLvo]=useState(userSettings.data[getLVOSettingsName(props.plot)]!=undefined?userSettings.data[getLVOSettingsName(props.plot)]:false);
  const isIvRangePlot = props.plotData.plot === "spt_ivr" && props.plotData.doix !== "1";
  const [ivRangeBottomPanelVisible, setIvRangeBottomPanelVisible] = useState(
    userSettings.data[getIvRangeBottomPanelVisibleName(props.plot)] !== undefined
      ? userSettings.data[getIvRangeBottomPanelVisibleName(props.plot)]
      : true,
  );
  const [ivRangeBottomPanelHeight, setIvRangeBottomPanelHeight] = useState(
    userSettings.data[getIvRangeBottomPanelHeightName(props.plot)] !== undefined
      ? userSettings.data[getIvRangeBottomPanelHeightName(props.plot)]
      : 24,
  );


  const handleChange = (event) => {
    const newValue = event.target.value;
    if (newValue === '' || (newValue>=BOTTOM_PANEL_HEIGHT_VAL["min"]  && newValue <= BOTTOM_PANEL_HEIGHT_VAL["max"])) {
      setValue(newValue);
    }
  };

  const handleBottomPanelViewChange = (event) => {
    setLCBottomPanelView(event.target.value);
  };

  const handleInfoPanelViewChange = (event) => {
    setInfoPanelView(event.target.value);
  };

  const handleIvRangeBottomPanelHeightChange = (event) => {
    const newValue = event.target.value;
    if (
      newValue === "" ||
      (newValue >= 10 && newValue <= BOTTOM_PANEL_HEIGHT_VAL["max"])
    ) {
      setIvRangeBottomPanelHeight(newValue);
    }
  };

  const autoFocus=()=>{
    const timeout = setTimeout(() => {
      if( inputRef.current)
      inputRef.current.focus();

    }, 100);

  }

  console.log(userSettings.data)

  const [uiDataState,setUIDataState]=useState({
    tpoGroupData:undefined,
    instrumentData:undefined,
    tpoGroups:undefined,
    isTPOLoaded:false,
    tableData:undefined
  })
  const {tpoGroupData,instrumentData,isTPOLoaded,tpoGroups,tableData}=uiDataState;

  const [settingsState,setSettingsState]=useState({
    settingsData:userSettings,
    isUserSettingsLoaded:userSettings!=undefined && userSettings.data!=undefined,
    apiTableData:userSettings.data.page_wise_hidden_columns  
  })
  const {settingsData,isUserSettingsLoaded,apiTableData}=settingsState;
  const [currentSettings,setCurrentSettings]=useState()
  
  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
  const [justSaved, setJustSaved] = useState(false);
  const saveCloseTimerRef = useRef(null);
  
  const { open, msg, severity } = msgState;

  useEffect(() => {
    return () => {
      if (saveCloseTimerRef.current) {
        clearTimeout(saveCloseTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    // document.title = "User Settings";
    // console.log("MP settings props instrument and data=",props.instrument,props.selectedInstrumentData)
    console.log("LCSettings statedata=",props.stateData,props.plot);
  }, []);
  
  const handleModalClose = () => {
    // setOpen(false);
    props.cancelHandler();
  };
  
  const [cancel,responseData, error, loaded, reset,executeAPI ] = useAxiosWithAuth();
  const [cancelSettings,responseDataSettings, errorSettings, loadedSettings, resetSettings,executeAPISettings ] = useAxiosWithAuth();
  const [cancelDefault,responseDataDefault, errorDefault, loadedDefault, resetDefault,executeAPIDefault ] = useAxiosWithAuth();
  const [cancelToken,responseDataToken, errorToken, loadedToken, resetToken,executeAPIToken ] = useAxiosWithAuth();

  const parentRef = useRef(null);
  const [parentWidth, setParentWidth] = useState(null);
  
  useEffect(() => {
    // Function to update parentWidth
    const updateParentWidth = () => {
      if (parentRef.current) {
        const width = parentRef.current.offsetWidth;
        console.log("parent width useeffect=",width)
        setParentWidth(width);
      }
    };

    // Initial update
    updateParentWidth();

    // Attach event listener for window resize
    window.addEventListener('resize', updateParentWidth);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateParentWidth);
    };
  }, [parentRef.current]);

  const LargeList = ({ data }) => {
    const height=window.innerHeight-120;
    const isLaptop=useMediaQuery('(min-width:1024px)')
    const is760=useMediaQuery('(min-width:640px)')
    let width=0
    if( isLaptop){
      width=(window.innerWidth*8/12)-20;
    }else if(is760){
      width=Math.max((window.innerWidth*10/12)-20,760)-40;
      // width=760-40;
    }else{
      width=760-40;
    }
   

    const rowRenderer = ({ index, key, style }) => (
      <div key={data[index].name} style={style}>
          <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4}}>
      <Typography sx={{mt:0,mr:5,fontSize:14,width:"140px"}}>{data[index].name}</Typography>
     
     <FormControl size="small" sx={{ width:"80px",minWidth:'80px',ml:2,mt:0 }}>
     <Select
       labelId="demo-simple-select-label"
       id="demo-simple-select"
       value={data[index].dailyTPO}
       MenuProps={MenuProps}
       sx={{height:"24px"}}
       onChange={(event)=>handleTPOChange(event,data[index],"daily")}
     >
       {data[index].tpo_list.map((tpo,index) => (
       <MenuItem value={tpo}>{tpo}</MenuItem>
       ))}
     </Select>
   </FormControl>
   <FormControl size="small" sx={{ width:"80px",minWidth:'80px',ml:2,mt:0 }}>
     <Select
       labelId="demo-simple-select-label"
       id="demo-simple-select"
       value={data[index].weeklyTPO}
       sx={{height:"24px"}}
       MenuProps={MenuProps}
       onChange={(event)=>handleTPOChange(event,data[index],"weekly")}
     >
       {data[index].tpo_list.map((tpo,index) => (
       <MenuItem value={tpo}>{tpo}</MenuItem>
       ))}
     </Select>
   </FormControl>
   <FormControl size="small" sx={{ width:"80px",minWidth:'80px',ml:2,mt:0 }}>
     <Select
       labelId="demo-simple-select-label"
       id="demo-simple-select"
       value={data[index].monthlyTPO}
       sx={{height:"24px"}}
       MenuProps={MenuProps}
       onChange={(event)=>handleTPOChange(event,data[index],"monthly")}
     >
       {data[index].tpo_list.map((tpo,index) => (
       <MenuItem value={tpo}>{tpo}</MenuItem>
       ))}
     </Select>
   </FormControl>
   <FormControl size="small" sx={{ width:"80px",minWidth:'80px',ml:2,mt:0 }}>
     <Select
       labelId="demo-simple-select-label"
       id="demo-simple-select"
       value={data[index].yearlyTPO}
       sx={{height:"24px"}}
       MenuProps={MenuProps}
       onChange={(event)=>handleTPOChange(event,data[index],"yearly")}
     >
       {data[index].tpo_list.map((tpo,index) => (
       <MenuItem value={tpo}>{tpo}</MenuItem>
       ))}
     </Select>
   </FormControl>
   </Box>
      </div>
    );
  
    console.log("width height=",width,height)
    return (
      <List
      width={width}
      height={height}
      rowCount={data.length}
      rowHeight={40}
      rowRenderer={rowRenderer}
      // autoHeight
      overscanRowCount={10}
      containerProps={{
        overflow: 'visible',
      }}
    />

    );
  };

  
  

/**
 * API response handler  
 */  
   useEffect(() => {
    if(loadedDefault){
      if(responseDataDefault!=null){
          
          setSelectedInstrument(responseDataDefault.data.default_instrument);
          const tpoData=processTPOData(tpoGroups,responseDataDefault);
          console.log("MP Settings : user setting response=",responseDataDefault,tpoData)
          setUIDataState((prevState)=>({
            ...prevState,
            tpoGroupData:tpoData    
          }));
        
          setSettingsState({settingsData:responseDataDefault,isUserSettingsLoaded:true,apiTableData:responseDataDefault.data.page_wise_hidden_columns});
      }
      else if(errorDefault!==null){
        setSettingsState((prevState)=>({
          ...prevState,
          isUserSettingsLoaded:true
        }))
        console.log("Error data=",errorDefault);
        setMsgState({open:true,msg:errorDefault?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirec it to login page
        if(errorDefault?.response?.status === 401 || errorDefault?.response?.status === 403){
          console.log("status received =",errorDefault?.response?.status)
          navigate(from, { replace: true });
        }
    }
    resetDefault();
    }
  },[loadedDefault,responseDataDefault]);

  /**
 * API response handler  for user settings save
 */  
   useEffect(() => {
    if(loadedSettings){
    
      if(responseDataSettings!=null){
        setSettingsState((prevState)=>({
            ...prevState,
            settingsData:responseDataSettings
          }));
          setUserSettings(responseDataSettings);
          console.log("Settings : user setting response=",responseDataSettings)
          setJustSaved(true);
          props.saveHandler(responseDataSettings);
          if (saveCloseTimerRef.current) {
            clearTimeout(saveCloseTimerRef.current);
          }
          saveCloseTimerRef.current = setTimeout(() => {
            setJustSaved(false);
          }, 900);
          async function saveFCMToken(){
            let fcmToken=null;
            try {
              fcmToken = await requestNotificationPermission();
              console.log("Login FCM Token:", fcmToken,responseData.role);
            } catch (error) {
              console.warn("Login FCM token not retrieved. User may have denied notifications.");
            }
            if (fcmToken) {
              // await sendFcmTokenToServer(fcmToken,accessToken);
              executeAPIToken(URL.SAVE_FCM_TOKEN,"POST",{fcm_token:fcmToken})
            } else {
              console.log("Login  Skipping FCM token submission due to permission denial.");
            }
            // navigate(from, { replace: true });
          }

          if(hasNotifAccess && isNotificationChanged){
            if(currentSettings.data.browser_push_notifications){
              // console.log("Registering FCM token");
              saveFCMToken();
            }else{
              // console.log("Degistering FCM token");
              deregisterFCMToken();
            }    
          }
       
      }
      else if(errorSettings!==null){
        console.log("Error data=",errorSettings);
        setMsgState({open:true,msg:errorSettings?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirect it to login page
        if(errorSettings?.response?.status === 401 || errorSettings?.response?.status === 403){
          console.log("status received =",errorSettings?.response?.status)
          navigate(from, { replace: true });
        }
    }
    resetSettings();
    }
  },[loadedSettings,responseDataSettings]);

  //FCM token save reponse handler
  useEffect(() => {
    if(loadedToken){
      if(responseDataToken!=null){
          console.log("Save FCM Token=",responseDataToken)
          
      }
      else if(errorToken!==null){
       
        setMsgState({open:true,msg:errorToken?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirec it to login page
        if(errorToken?.response?.status === 401 || errorToken?.response?.status === 403){
          console.log("status received =",errorToken?.response?.status)
          navigate(from, { replace: true });
        }
    }
    resetToken();
    }
  },[loadedToken,responseDataToken]);


    //execute the data fetch on the component mount
    useEffect(()=>{
      // let data={
      //   "symbol": "NIFTY",
      //   "instruments": 1,
      //   // "tpoList": 1,
      //   // "snakechart_data": 1
      //   "user_settings_form" : 1
      // }
      // executeAPI(URL.MPCHART_UIDATA,"POST",data); 
    },[]);
  
    const processTPOData=(data,userSettings)=>{
      let processedData=[];
      for (const key in data) {
        // console.log(key, data[key])
        let temp=data[key];
        temp.key=key;
        //  temp.name=key;
        temp.name=key.replace(/_OPT/,' OPTIONS');
        // console.log("daily tpo in settings =",userSettings.data.tf_tpo_map[key].daily);
        if(key in userSettings.data.tf_tpo_map){
          temp.dailyTPO=userSettings.data.tf_tpo_map[key].daily
          temp.weeklyTPO=userSettings.data.tf_tpo_map[key].weekly
          temp.monthlyTPO=userSettings.data.tf_tpo_map[key].monthly
          temp.yearlyTPO=userSettings.data.tf_tpo_map[key].yearly
          processedData.push(temp);
        } else {
          temp.dailyTPO=data[key].default_tpo;
          temp.weeklyTPO=data[key].default_tpo*data[key].tf_factor.weekly;
          temp.monthlyTPO=data[key].default_tpo*data[key].tf_factor.monthly;
          temp.yearlyTPO=data[key].default_tpo*data[key].tf_factor.yearly;
          processedData.push(temp);
        }

      }
      return processedData;
    }

    /**
   * API response handler  
   */  
     useEffect(() => {
      if(loaded){
        if(responseData!=null){
          responseData.instruments = responseData.instruments.map((item) =>
            transformAndReverseMap(item)
          );
            console.log("MPCHart UI Data response=",responseData)
          const tpoData=processTPOData(responseData.tpo_groups,userSettings);
          console.log("MP Settings 2 MPCHart UI Data response=",responseData,tpoData)
           setUIDataState({tpoGroupData:tpoData,tpoGroups:responseData.tpo_groups,instrumentData:responseData.instruments, isTPOLoaded:true,tableData:responseData.user_settings_form.page_wise_columns});
           setOptions (responseData.instruments);
        }
        else if(error!==null){
          setUIDataState({tpoGroupData:undefined,tpoGroups:undefined,instrumentData:undefined,isTPOLoaded:true,tableData:undefined});
          console.log("Error data=",error);
          setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          //if unauthorized then redirec it to login page
          if(error?.response?.status === 401 || error?.response?.status === 403){
            console.log("status received =",error?.response?.status)
            navigate(from, { replace: true });
          }
      }
      reset();
      }
    },[loaded,responseData]);
    
    useEffect(()=>{
      console.log("searchText=", searchText );
      if(instrumentData!=undefined){
        if(searchText=="")
        setOptions(instrumentData)
        else{
          const temp=instrumentData.filter((option) => containsText(option, searchText))
          setOptions(temp);
        }
      }
    },[searchText])
  
    const handleInstrumentChange = (event) => {
      setSelectedInstrument(event.target.value);
    }  

    const handleVPChange = (event) => {
      setVPType(event.target.value);
    };

    const handleVAChange = (event) => {
      setVAType(event.target.value);
    };

    const handleLocaleChange = (event) => {
      setNumberFormatLocale(event.target.value);
    };

    const handleDataTypeChange = (event) => {
      console.log(event.target.value);
      setDataTypeContracts(event.target.value==="true");
    };

    // const handleMainePanelViewChange = (event) => {
    //   setLCMainPanelView(event.target.value);
    // };

    const handleOFZoomChange = (event) => {
      setOrdeflowZoomType(event.target.value);
    };

    const handleTPOChange=(event,data,type)=>{
      let newData=JSON.parse(JSON.stringify(tpoGroupData));
      let index=newData.findIndex(item=>item.key==data.key)
      if(index==-1)
      return;

      if(type=="daily"){
        newData[index].dailyTPO=event.target.value;
      }
      else if(type=="weekly"){
        newData[index].weeklyTPO=event.target.value;
      }
      else if(type=="monthly"){
        newData[index].monthlyTPO=event.target.value;
      }
      else if(type=="yearly"){
        newData[index].yearlyTPO=event.target.value;
      }
      setUIDataState((prevState) => ({
        ...prevState,
       tpoGroupData:newData
      }));
      
    }

    const disableAutosave=()=>{
      setAutosaveInterval(0);
    }

    const saveSettings=()=>{
    captureChartInteraction('charts_chart_setting_changed', { setting_name: 'line_chart' });
    //   let newData=JSON.parse(JSON.stringify(userSettings));
    let newData={};
    newData.data={};
   
    if(isD3BasedLineChart(props.plotData.plot,props.plotData.doix)==false)
    newData.data.default_lc_ndays=parseInt(defaultLineChartNDays);

    newData.data.number_format_locale=numberFormatLocale;
    newData.data.data_in_contracts=dataTypeContracts;
    // newData.data.lc_main_panel_view=lcMainPanelView;
    if(isIvRangePlot){
      newData.data[getIvRangeBottomPanelVisibleName(props.plot)] =
        ivRangeBottomPanelVisible;
      newData.data[getIvRangeBottomPanelHeightName(props.plot)] = parseInt(
        ivRangeBottomPanelHeight,
        10,
      );
    } else if(isD3BasedLineChart(props.plotData.plot,props.plotData.doix)){  
    newData.data[getBottomPanelViewName(props.plot)]=lcBottomPanelView;
    newData.data[getBottomPanelHeightName(props.plot)]=parseInt(value);
    newData.data[getInfoPanelViewName(props.plot)]=infoPanelView;
    }
  
     if(isGammaAndMvizSettingsAvailable(props.plotData.plot,props.plotData.doix,isAdmin)){  
      newData.data[getGammaSettingsName(props.plot)]=showGammaLines;
      if(props.plotData.plot!="all_volx")
      newData.data[getMvizSettingsName(props.plot)]=showMvizLines;
    }
   if(isLvoSettingsAvailable(props.plotData.plot,props.plotData.doix)){
    newData.data[getLVOSettingsName(props.plot)]=showLvo;
   }
    if(hasNotifAccess)
      newData.data.browser_push_notifications=browserPushNotification;

      
      setCurrentSettings(newData);
      console.log("Saved setting=",newData);

      let data={"data":newData};

      executeAPISettings(URL.UPDATE_USER_SETTING,"POST",newData.data);

      
     
    }
    useEffect(()=>{
      setSelectedInstrument(settingsData.data.default_instrument);
      setShowGlobalVolumeProfile(settingsData.data.show_global_vp);
      setShowAllVolumeProfile(settingsData.data.show_all_vp);
      setShowGlobalVolumeNumberProfile(settingsData.data.show_global_vp_numbers);
      setShowAllVolumeNumber(settingsData.data.show_profile_vp_numbers);
      setShowUiNpocKrl(settingsData.data.show_ui_npoc_krl);
      setShowKrl(settingsData.data.show_krl);
      setShowCustomKrl(settingsData.data.custom_krl_display);
      setCustomKrlMultipleAnchor(settingsData.data.custom_krl_overlapping_anchoring);
      setAnchorVwap2sdDisplay(settingsData.data.show_2sd_band_custom_anchored_krl);
      setShowOFMetadata(settingsData.data.show_metadata_marker_of)
      setShowOFNPOC(settingsData.data.show_ui_npoc_krl_of);
      setOrdeflowZoomType(settingsData.data.of_zoom_type?settingsData.data.of_zoom_type:OF_ZOOM_TYPE.ASYMMETRIC);
      setVPType(settingsData.data.vp_type)
      setVAType(settingsData.data.va_type)
      setOptions (instrumentData);
      setMaxCompositeDays(settingsData.data.max_ndays_for_composite);
      setDefaultLineChartNDays(settingsData.data.default_lc_ndays);
      setAutosaveInterval(settingsData.data.autosave_interval);
      setNumberFormatLocale(settingsData.data.number_format_locale);
      setDataTypeContracts(settingsData.data.data_in_contracts);
      if(hasNotifAccess)
        setBrowserPushNotification(settingsData.data.browser_push_notifications!=undefined?settingsData.data.browser_push_notifications:false);

      
    },[settingsData])

    const discardChanges=()=>{
      setJustSaved(false);
      setUIDataState((prevState) => ({
        ...prevState,
       isTPOLoaded:false,
      }));
      setOptions (undefined);
      setSelectedInstrument(settingsData.data.default_instrument);
      setShowGlobalVolumeProfile(settingsData.data.show_global_vp);
      setShowAllVolumeProfile(settingsData.data.show_all_vp);
      setShowGlobalVolumeNumberProfile(settingsData.data.show_global_vp_numbers);
      setShowAllVolumeNumber(settingsData.data.show_profile_vp_numbers);
      setShowUiNpocKrl(settingsData.data.show_ui_npoc_krl);
      setShowKrl(settingsData.data.show_krl);
      setShowCustomKrl(settingsData.data.custom_krl_display);
      setCustomKrlMultipleAnchor(settingsData.data.custom_krl_overlapping_anchoring);
      setAnchorVwap2sdDisplay(settingsData.data.show_2sd_band_custom_anchored_krl);
      setShowOFMetadata(settingsData.data.show_metadata_marker_of)
      setShowOFNPOC(settingsData.data.show_ui_npoc_krl_of);
      setOrdeflowZoomType(settingsData.data.of_zoom_type?settingsData.data.of_zoom_type:OF_ZOOM_TYPE.ASYMMETRIC);
      setVPType(settingsData.data.vp_type)
      setVAType(settingsData.data.va_type)
      setOptions (instrumentData);
      setMaxCompositeDays(settingsData.data.max_ndays_for_composite);
      setDefaultLineChartNDays(settingsData.data.default_lc_ndays);
      setAutosaveInterval(settingsData.data.autosave_interval);
      setNumberFormatLocale(settingsData.data.number_format_locale);
      setDataTypeContracts(settingsData.data.data_in_contracts);
      // setLCMainPanelView(settingsData.data.lc_main_panel_view?settingsData.data.lc_main_panel_view:MAIN_PANEL_ON_BOTTOM_PANEL.HIDE);
      setLCBottomPanelView(settingsData.data[getBottomPanelViewName(props.plot)]?settingsData.data[getBottomPanelViewName(props.plot)]:MAIN_PANEL_ON_BOTTOM_PANEL.SHOW);
      setValue(settingsData.data[getBottomPanelHeightName(props.plot)]?settingsData.data[getBottomPanelHeightName(props.plot)]:getBottomPanelDefaultHeight(props.plot));
      setInfoPanelView(settingsData.data[getInfoPanelViewName(props.plot)]?settingsData.data[getInfoPanelViewName(props.plot)]:INFO_PANEL_VIEWS.EXPANDED);
      setShowLvo(settingsData.data[getLVOSettingsName(props.plot)]?settingsData.data[getLVOSettingsName(props.plot)]:false);
      setShowGammaLines(settingsData.data[getGammaSettingsName(props.plot)]!=undefined?settingsData.data[getGammaSettingsName(props.plot)]:true);
      setShowMvizLines(settingsData.data[getMvizSettingsName(props.plot)]!=undefined?settingsData.data[getMvizSettingsName(props.plot)]:true);
      setIvRangeBottomPanelVisible(
        settingsData.data[getIvRangeBottomPanelVisibleName(props.plot)] !==
          undefined
          ? settingsData.data[getIvRangeBottomPanelVisibleName(props.plot)]
          : true,
      );
      setIvRangeBottomPanelHeight(
        settingsData.data[getIvRangeBottomPanelHeightName(props.plot)] !==
          undefined
          ? settingsData.data[getIvRangeBottomPanelHeightName(props.plot)]
          : 24,
      );
  
      
     
      if(hasNotifAccess)
        setBrowserPushNotification(settingsData.data.browser_push_notifications!=undefined?settingsData.data.browser_push_notifications:false);


      setSettingsState((prevState)=>({
        ...prevState,
        apiTableData:settingsData.data.page_wise_hidden_columns  
      }))
     
      const tpoData=processTPOData(tpoGroups,settingsData);
      // console.log(tpoData)
      setUIDataState({tpoGroupData:tpoData,tpoGroups:tpoGroups,instrumentData:instrumentData, isTPOLoaded:true,tableData:tableData});
      
    }

    const resetToDefault=()=>{
      setSettingsState((prevState)=>({
        ...prevState,
        isUserSettingsLoaded:false
      }))
      // /api/user/settings?reset=true
      executeAPIDefault(`${URL.USER_SETTING}?reset=true`,"GET",{});

    }


  const hasUnsavedChanges = useMemo(() => {
    if (!settingsData?.data || justSaved) return false;
    const d = settingsData.data;
    if (numberFormatLocale !== d.number_format_locale) return true;
    if (dataTypeContracts !== d.data_in_contracts) return true;
    if (!isD3BasedLineChart(props.plotData.plot, props.plotData.doix)) {
      if (String(defaultLineChartNDays) !== String(d.default_lc_ndays)) return true;
    } else if (isIvRangePlot) {
      const visibleKey = getIvRangeBottomPanelVisibleName(props.plot);
      const heightKey = getIvRangeBottomPanelHeightName(props.plot);
      if (ivRangeBottomPanelVisible !== d[visibleKey]) return true;
      if (String(ivRangeBottomPanelHeight) !== String(d[heightKey])) return true;
    } else {
      const viewKey = getBottomPanelViewName(props.plot);
      const heightKey = getBottomPanelHeightName(props.plot);
      const infoKey = getInfoPanelViewName(props.plot);
      if (lcBottomPanelView !== d[viewKey]) return true;
      if (String(value) !== String(d[heightKey])) return true;
      if (infoPanelView !== d[infoKey]) return true;
    }
    if (isGammaAndMvizSettingsAvailable(props.plotData.plot, props.plotData.doix, isAdmin)) {
      const gammaKey = getGammaSettingsName(props.plot);
      if (showGammaLines !== d[gammaKey]) return true;
      if (props.plotData.plot != "all_volx") {
        const mvizKey = getMvizSettingsName(props.plot);
        if (showMvizLines !== d[mvizKey]) return true;
      }
    }
    if (isLvoSettingsAvailable(props.plotData.plot, props.plotData.doix)) {
      const lvoKey = getLVOSettingsName(props.plot);
      if (showLvo !== d[lvoKey]) return true;
    }
    if (hasNotifAccess && browserPushNotification !== d.browser_push_notifications) return true;
    return false;
  }, [
    settingsData, justSaved, numberFormatLocale, dataTypeContracts, defaultLineChartNDays,
    lcBottomPanelView, value, infoPanelView, showGammaLines, showMvizLines, showLvo,
    ivRangeBottomPanelVisible, ivRangeBottomPanelHeight, isIvRangePlot,
    hasNotifAccess, browserPushNotification, props.plot, props.plotData, isAdmin,
  ]);

/**
 * autoclosing of the snackbar msg bar 
 */ 
   const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
};

  const handleColumnChange=(event,col,type)=>{
    if(event.target.checked){
      console.log("col,type",col,type)
      let data=JSON.parse(JSON.stringify(apiTableData));
      if(!(type in data)) data[type]=[];
      // console.log(data);
      data[type].push(col);
      // console.log(data[type]);
      setSettingsState((prevState)=>({
        ...prevState,
        apiTableData:data
      }));
    }else{
      let data=JSON.parse(JSON.stringify(apiTableData));
      data[type] = data[type].filter(item => item !== col)
      console.log(data[type]);
      setSettingsState((prevState)=>({
        ...prevState,
        apiTableData:data
      }));
    }
  }

  const handleNotificationChange=(val)=>{
    setBrowserPushNotification(val);
    setNotificationChanged(true)
  
  }

  return (
    <Modal open={modalOpen} onClose={handleModalClose}>
    <>
    {isUserSettingsLoaded?
     <Box sx={style} >
         <SettingsModalCloseButton onClose={handleModalClose} />
    <Grid container spacing={2}>
    <Grid item mobile={0} tablet={1} laptop={2}>
     
    </Grid>
    <Grid item mobile={12} tablet={10} laptop={8} sx={{minWidth:"760px",ml:2,mr:2}}>
        
    {isD3BasedLineChart(props.plotData.plot,props.plotData.doix)?            
    <>
    <Box sx={{display:"flex",mr:1,mt:2}}><Typography sx={{mt:2,fontSize:24,fontWeight:'bold'}}>{getLineChartSettingsName(props.plotData.plot,props.plotData.doix)} - Local Settings</Typography>
      <HtmlTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">Local settings applicable for this specific {getLineChartSettingsName(props.plotData.plot,props.plotData.doix)} type across all instruments</Typography>
                {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
                {"It's very engaging. Right?"} */}
              </React.Fragment>
            }
          >
          <InfoIcon sx={{ml:1,marginTop:"24px"}}></InfoIcon>
        </HtmlTooltip>
      </Box>

      <Box sx={{backgroundColor:'primaryTheme.shade03',mt:2,pb:2,mb:6,pr:2,borderRadius:5,width:"100%"}}>
        
      {isIvRangePlot ? (
        <>
          <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
            <Box sx={{width:"272px",display:"flex"}}>
              <Typography sx={{mr:1,mt:1,fontSize:14}}>Show Bottom (SD) Panel</Typography>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit">Show or hide the standard-deviation (SD) sub-panel below the main IV Range price panel.</Typography>
                  </React.Fragment>
                }
              >
                <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
              </HtmlTooltip>
            </Box>
            <Switch
              checked={ivRangeBottomPanelVisible}
              color="secondary"
              onChange={() => setIvRangeBottomPanelVisible(!ivRangeBottomPanelVisible)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Box>
          <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
            <Box sx={{width:"272px",display:"flex"}}>
              <Typography sx={{mr:1,mt:1,fontSize:14}}>Bottom Panel Height (%)</Typography>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit">SD panel height as a percentage of the main chart area [10,60].</Typography>
                  </React.Fragment>
                }
              >
                <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
              </HtmlTooltip>
            </Box>
            <TextField
              size="small"
              label=""
              type="number"
              value={ivRangeBottomPanelHeight}
              onChange={handleIvRangeBottomPanelHeightChange}
              disabled={!ivRangeBottomPanelVisible}
              sx={{height:"25px",ml:1,padding:"3px"}}
              inputProps={{ min: 10, max: BOTTOM_PANEL_HEIGHT_VAL["max"] }}
            />
          </Box>
        </>
      ) : (
        <>
      <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
              <Box sx={{width:"272px",display:"flex"}}>
                  <Typography sx={{mr:1,mt:2,fontSize:14}}>Bottom Panel Visibilty</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">Bottom Panel Visibility</Typography>
                       
                        {/* <li>None: No Volume profile shown by default.</li> */}
                        <li>Top Layer: Show bottom panel at top of main panel.</li>
                        <li>Same Container: Main panel overlap with bottom panel.</li>
                        <li>Hidden: Hide bottom panel.</li>
                       
                        
                      </React.Fragment>
                    }
                  >
                  <InfoIcon sx={{marginTop:"14px"}}></InfoIcon>
                </HtmlTooltip>
              </Box>
      
            <RadioGroup
            row
            sx={{ml:1,mt:1}}
            size='small'
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
               <FormControlLabel value={BOTTOM_PANEL_VIEWS.TOP_LAYER}
              control={<Radio checked={lcBottomPanelView === BOTTOM_PANEL_VIEWS.TOP_LAYER} onChange={handleBottomPanelViewChange} size="small" />} 
              label={<Typography sx={{fontSize:14}}>Top Layer</Typography>} />
              <FormControlLabel value={BOTTOM_PANEL_VIEWS.SAME_CONTAINER}
              control={<Radio checked={lcBottomPanelView === BOTTOM_PANEL_VIEWS.SAME_CONTAINER} onChange={handleBottomPanelViewChange} size="small" />} 
              label={<Typography sx={{fontSize:14}}>Same Container</Typography>} />
               <FormControlLabel value={BOTTOM_PANEL_VIEWS.HIDDEN}
              control={<Radio checked={lcBottomPanelView === BOTTOM_PANEL_VIEWS.HIDDEN} onChange={handleBottomPanelViewChange} size="small" />} 
              label={<Typography sx={{fontSize:14}}>Hidden</Typography>} />
          </RadioGroup>
        </Box>
        <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
        <Box sx={{width:"272px",display:"flex"}}>
          <Typography sx={{mr:1,mt:1,fontSize:14}}>Bottom Panel Height (%)</Typography>
          <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">Bottom panel height w.r.to main panel height in percentage [5,60]</Typography>
                         </React.Fragment>
                  }
                >
              <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
            </HtmlTooltip>
        </Box>
              <TextField
                size="small"
                label=""
                type="number"
                value={value}
                onChange={handleChange}
                sx={{height:"25px",ml:1,padding:"3px"}}
                inputProps={{ min: BOTTOM_PANEL_HEIGHT_VAL["min"], max: BOTTOM_PANEL_HEIGHT_VAL["max"] }}
                // fullWidth
          />
        </Box>
        <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
              <Box sx={{width:"272px",display:"flex"}}>
                  <Typography sx={{mr:1,mt:2,fontSize:14}}>Info Panel Visibilty</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">Info Panel Visibility</Typography>
                        <li>Expanded: Default Info panel will be exapnded view.</li>
                        <li>Collapsed: Default Info panel will be collapsed view.</li>
                      </React.Fragment>
                    }
                  >
                  <InfoIcon sx={{marginTop:"14px"}}></InfoIcon>
                </HtmlTooltip>
              </Box>
      
            <RadioGroup
            row
            sx={{ml:1,mt:1}}
            size='small'
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
               <FormControlLabel value={INFO_PANEL_VIEWS.EXPANDED}
              control={<Radio checked={infoPanelView === INFO_PANEL_VIEWS.EXPANDED} onChange={handleInfoPanelViewChange} size="small" />} 
              label={<Typography sx={{fontSize:14}}>Expanded</Typography>} />
               <FormControlLabel value={INFO_PANEL_VIEWS.COLLAPSED}
              control={<Radio checked={infoPanelView === INFO_PANEL_VIEWS.COLLAPSED} onChange={handleInfoPanelViewChange} size="small" />} 
              label={<Typography sx={{fontSize:14}}>Collapsed</Typography>} />
             
          </RadioGroup>
        </Box>
        </>
      )}
        {isGammaAndMvizSettingsAvailable(props.plotData.plot,props.plotData.doix,isAdmin)? 
        <>
        <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
              <Box sx={{width:"272px",display:"flex"}}>
                  <Typography sx={{mr:1,mt:1,fontSize:14}}>Show Gamma Wall Lines</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">Always show Gamma Wall Lines by default (PE Wall, CE Wall).<br/>Gamma Reference or Gamma Zero Line is always visible.</Typography>
                        
                      </React.Fragment>
                    }
                  >
                  <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
                </HtmlTooltip>
              </Box>
      
              <Switch checked={showGammaLines} color="secondary"
            onChange={()=>setShowGammaLines(!showGammaLines)}
            inputProps={{ 'aria-label': 'controlled' }}></Switch>
        </Box>
        {props.plotData.plot!="all_volx"?
        <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
              <Box sx={{width:"272px",display:"flex"}}>
                  <Typography sx={{mr:1,mt:1,fontSize:14}}>Show mViz Lines</Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <Typography color="inherit">Always show mViz Lines by default </Typography>
                        
                      </React.Fragment>
                    }
                  >
                  <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
                </HtmlTooltip>
              </Box>
      
              <Switch checked={showMvizLines} color="secondary"
            onChange={()=>setShowMvizLines(!showMvizLines)}
            inputProps={{ 'aria-label': 'controlled' }}></Switch>
        </Box>:
        <></>
          }

        </>:
        <></>
        }
      {isLvoSettingsAvailable(props.plotData.plot,props.plotData.doix)?
      <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%"}}>
      <Box sx={{width:"272px",display:"flex"}}>
          <Typography sx={{mr:1,mt:1,fontSize:14}}>Show Intra Volx lines only</Typography>
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">If this setting is set and saved, chart will only show active Intra day Volx lines.<br/><br/>By default the Volx Lines for all dates are shown if this setting is Disabled.<br/><br/>This is helpful, when the previous day was expiry and the Volx volumes range was so large that next day Intra volx lines are barely visible.</Typography>
                
              </React.Fragment>
            }
          >
          <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
        </HtmlTooltip>
      </Box>

      <Switch checked={showLvo} color="secondary"
    onChange={()=>setShowLvo(!showLvo)}
    inputProps={{ 'aria-label': 'controlled' }}></Switch>
</Box>:<></>

      }
        </Box>  
        </>:
        <></>
        }
       
      
     
    {isD3BasedLineChart(props.plotData.plot,props.plotData.doix)==false? 
    <>
    <Box sx={{display:"flex",mr:1,mt:0}}><Typography sx={{mt:2,fontSize:24,fontWeight:'bold'}}>Line Chart - Global Settings</Typography>
      <HtmlTooltip
            title={
              <React.Fragment>
                <Typography color="inherit">Global settings applicable across Line Charts for all instruments in general</Typography>
              </React.Fragment>
            }
          >
          <InfoIcon sx={{ml:1,marginTop:"24px"}}></InfoIcon>
        </HtmlTooltip>
      </Box>
    
    <Box sx={{backgroundColor:'primaryTheme.shade03',mt:2,pb:2,mb:5,pr:2,borderRadius:5,width:"100%"}}>
      <FormControl variant="standard" size="small" sx={{ minWidth:"80%",ml:2,mt:1 }}>
     
      
        <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:2,mt:1,width:"100%"}}>
        <Box sx={{width:"272px",display:"flex"}}>
          <Typography sx={{mr:1,mt:1,fontSize:14}}>Default nDays for Line Charts</Typography>
          <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">Default number of days of data to plot on Line Charts [-1 to 6]</Typography>
                      You can override this value on Line Charts page by explicitly specifying the nDays parameter in URL.
                    </React.Fragment>
                  }
                >
              <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
            </HtmlTooltip>
        </Box>
        <TextField size="small" type="number" value={defaultLineChartNDays} 
             onChange={(e) => {
              if(e.target.value<=6 && e.target.value>=-1)
                setDefaultLineChartNDays(parseInt(e.target.value))
            }}
            sx={{height:"25px",ml:1,padding:"3px"}} inputProps={{ min: -1, max: 6,height:"25px",padding:"3px" }} />
      </Box>
       
     
      </FormControl>
      </Box>
      </>:
      <></>
    }
    
    <Box sx={{display:"flex",mr:1,mt:0}}><Typography sx={{mt:2,fontSize:24,fontWeight:'bold'}}>Global Settings</Typography>
    <HtmlTooltip
          title={
            <React.Fragment>
              <Typography color="inherit">Global settings applicable across all charts</Typography>
              {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '}
              {"It's very engaging. Right?"} */}
            </React.Fragment>
          }
        >
        <InfoIcon sx={{ml:1,marginTop:"24px"}}></InfoIcon>
      </HtmlTooltip>
    </Box>
    <Box sx={{backgroundColor:'primaryTheme.shade03',mt:2,pb:2,mb:6,pr:2,borderRadius:5,width:"100%"}}>
    
    <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%",marginTop:"0px"}}>
        <Box sx={{width:"272px",display:"flex"}}>
          <Typography sx={{mr:1,mt:2,fontSize:14}}>Locale for Number Formatting</Typography>
          <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">Locale used for formatting large numbers across all pages</Typography>
                      Indian locale formats the numbers in Lakhs, Crores format. <br/>
                      US locale formats data in millions and billions
                    </React.Fragment>
                  }
                >
              <InfoIcon sx={{marginTop:"16px"}}></InfoIcon>
            </HtmlTooltip>
        </Box>
        <FormControlLabel value="en-In" 
          control={<Radio checked={numberFormatLocale === 'en-In'} onChange={handleLocaleChange} size="small"  sx={{mt:1}}/>} 
          label={<Typography sx={{fontSize:14, mt:1}}>Indian Format</Typography>} />
          <FormControlLabel value="en-Us" 
          control={<Radio checked={numberFormatLocale === 'en-Us'} onChange={handleLocaleChange} size="small" sx={{mt:1}} />} 
          label={<Typography sx={{fontSize:14, mt:1}}>US Format</Typography>} />
        
      </Box>
      <Box display="flex" justifyContent="flex-start" sx={{mb:1,ml:4,width:"100%",marginTop:"2px"}}>
        <Box sx={{width:"272px",display:"flex"}}>
          <Typography sx={{mr:1,mt:1,fontSize:14}}>OI and Vol Data</Typography>
          <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">OI and Volume data across all pages should be displayed in #Contracts vs Total value?</Typography>
                    </React.Fragment>
                  }
                >
              <InfoIcon sx={{marginTop:"6px"}}></InfoIcon>
            </HtmlTooltip>
        </Box>
        <FormControlLabel value="true" 
          control={<Radio checked={dataTypeContracts} onChange={handleDataTypeChange} size="small" />} 
          label={<Typography sx={{fontSize:14}}>Contracts</Typography>} />
          <FormControlLabel value="false" 
          control={<Radio checked={!dataTypeContracts} onChange={handleDataTypeChange} size="small" />} 
          label={<Typography sx={{fontSize:14}}>Total Value</Typography>} />
        
      </Box>
   
      {hasNotifAccess?
      <>
       <Box display="flex" justifyContent="flex-start" sx={{ mb: 0, ml: 4, mt: 1, width: "100%" }}>
          <Box sx={{ width: "260px", display: "flex" }}>
            <Typography sx={{ mr: 1, mt: 1, fontSize: 14 }}>Browser Push Notification</Typography>
            <HtmlTooltip
              title={
                    <React.Fragment>
                       <Typography color="inherit">{TEXT_MSGS.INFO_BROWSER_NOTIFICATION_POP_UP}</Typography>
                    </React.Fragment>
                    }
            >
             <InfoIcon sx={{ marginTop: "6px" }}></InfoIcon>
            </HtmlTooltip>
           </Box>

            <Switch checked={browserPushNotification} color="secondary"
               onChange={() => handleNotificationChange(!browserPushNotification)}
              inputProps={{ 'aria-label': 'controlled' }}></Switch>

        </Box> 
        {isNotificationChanged?
        <Box sx={{ml:4}}>
          <Typography  variant="warningText"sx={{ mr: 1, mt: 0,ml:0, fontSize: 14 }}>
            {browserPushNotification?TEXT_MSGS.MSG_NOTIFICATION_ENABLED :TEXT_MSGS.MSG_NOTIFICATION_DISABLED} </Typography> 
            </Box>  
          :
          <></>
        }
        </>
        :<></>
        }  

    </Box>
    </Grid>
    <Grid item mobile={0} tablet={1} laptop={2}>
     
    </Grid>
    
   
</Grid>
<SettingsFooterPopup saveSettings={saveSettings} discardChanges={discardChanges} resetDefault={resetToDefault} hasUnsavedChanges={hasUnsavedChanges} justSaved={justSaved}>

</SettingsFooterPopup>
</Box>    :
<>
<CircularProgress sx={{marginTop:"20%",marginLeft:"45%"}}/></>}
        <AppErrorPopup
          open={open}
          message={msg}
          severity={severity}
          onClose={handleClose}
          showCloseX
        />
        {/* Legacy snackbar (replaced by AppErrorPopup)
        <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} >
          <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>
        </Snackbar>
        */}
       </>
       </Modal>
  )
}

export default LineChartSettingsNew
   